import {
  CheckoutElementsProvider,
  ContactDetailsElement,
  PaymentElement,
  useCheckoutElements,
} from "@stripe/react-stripe-js/checkout";
import { useState, type FormEvent } from "react";
import { appearance, stripePromise } from "./stripe";

function DepositForm() {
  const state = useCheckoutElements();
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (state.type !== "success" || submitting) return;
    setSubmitting(true);
    setMessage(null);
    // Redirects to the session's return_url (this order's page) on success.
    const result = await state.checkout.confirm();
    if (result.type === "error") setMessage(result.error.message);
    setSubmitting(false);
  };

  return (
    <form onSubmit={onSubmit}>
      <h3>Contact</h3>
      <ContactDetailsElement />
      <h3>Payment</h3>
      <PaymentElement options={{ layout: "tabs" }} />
      {message && (
        <div className="notice notice--warn" role="alert" style={{ marginTop: 16 }}>
          {message}
        </div>
      )}
      <button
        type="submit"
        className="btn btn--lg btn--block"
        disabled={state.type !== "success" || submitting}
        style={{ marginTop: 20 }}
      >
        {submitting
          ? "Processing…"
          : state.type === "success"
            ? `Pay deposit of ${state.checkout.total.total.amount}`
            : "Loading…"}
      </button>
      <p className="muted" style={{ fontSize: "0.8rem", textAlign: "center" }}>
        Your card is saved securely with Stripe so we can bill the balance when the order is ready.
      </p>
    </form>
  );
}

/** Pay a contractor deposit with Stripe Elements, from the deposit's Checkout Session. */
export function DepositPayment({ clientSecret }: { clientSecret: string }) {
  if (!stripePromise) {
    return (
      <div className="notice notice--warn">
        Online payments aren&rsquo;t configured. Set <code>VITE_STRIPE_PUBLISHABLE_KEY</code> in <code>.env</code>.
      </div>
    );
  }
  return (
    <CheckoutElementsProvider
      key={clientSecret}
      stripe={stripePromise}
      options={{ clientSecret, elementsOptions: { appearance: appearance() } }}
    >
      <DepositForm />
    </CheckoutElementsProvider>
  );
}
